import DisplayField from '@shared/components/displays/display-field/display-field.vue';
// import CardMock from '@shared/components/mocks/table-mock/card-mock.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { BPCDisplayConfigField } from '@core/interfaces/bpc-display-config';
import GenericDetails from '../generic-details/generic-details.vue';

@Component({
  name: 'bpc-entity-card',
  components: {
    // 'bpc-card-mock': CardMock,
    'bpc-display-field': DisplayField,
    'bpc-generic-details': GenericDetails,
  },
})
export default class EntityCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;
  @Prop(Array) readonly fields: BPCDisplayConfigField[];
  @Prop(Array) readonly hiddenFields: string[];
  @Prop(Array) readonly mainFields: string[];
  @Prop(Boolean) readonly loading: boolean;
  @Prop(String) readonly cardComponent: string;
}
